import { useState } from 'react';

import { useSelector } from 'react-redux';

import AddPropertyForTour from './AddPropertyForTour';
import AddTimeSlot from './AddTimeSlot';
import classes from './Property.module.css';

import useWindowDimesions from '../../hooks/windowDimensions';

const RequestForTour = ({ onCancel }) => {
  const { width, height } = useWindowDimesions();
  const [isAddTimeSlot, setIsAddTimeSlot] = useState(false);
  const options = useSelector((state) => state.optRed.data.options);
  const propertyOptionsForTour = options?.filter(
    (option) => option.shortListed && !option.tourRequestedDate,
  );
  const selectAllPropertiesForTour = propertyOptionsForTour?.map((option) => {
    return { ...option, isSelectedForTour: true };
  });
  const [selectedProperties, setSelectedProperties] = useState(selectAllPropertiesForTour);

  const onNextClick = (selectedProperties) => {
    if (selectedProperties) {
      setSelectedProperties(selectedProperties);
    }
    setIsAddTimeSlot(!isAddTimeSlot);
  };

  const onCancelClick = () => {
    onCancel();
  };

  const onTourClick = () => {
    onCancel();
  };

  return (
    <div
      className={classes.requestForTour_container}
      style={{ width: width / 1.6, height: height - 100 }}
    >
      {!isAddTimeSlot ? (
        <AddPropertyForTour
          options={selectedProperties}
          onNextClick={onNextClick}
          onCancelClick={onCancelClick}
        ></AddPropertyForTour>
      ) : (
        <AddTimeSlot
          onBackClick={onNextClick}
          selectedProperties={selectedProperties}
          onTourClick={onTourClick}
        ></AddTimeSlot>
      )}
    </div>
  );
};

export default RequestForTour;
